var AuthService = (function () {

    // function loginSubmit() {
    //     var email = $('#js-input-user-login-email'),
    //         password = $('#js-input-user-login-password');
    //
    //     $('.has-error').removeClass('has-error');
    //     var isValid = true;
    //
    //     if (email.val().length < 3) {
    //         isValid = false;
    //         AppService.displayError('Обязательное поле', email);
    //     }
    //
    //     if (password.val().length < 6) {
    //         isValid = false;
    //         AppService.displayError('Пароль не может быть меньше 6 символов', password);
    //     }
    //
    //     if (!isValid) {
    //         return false;
    //     }
    //
    //     AppService.toggleLoader();
    //
    //     var data = {
    //         email: email.val(),
    //         password: password.val()
    //     };
    //
    //     $.ajax({
    //         url: $(this).prop('action'),
    //         type: $(this).prop('method'),
    //         data: JSON.stringify(data),
    //         contentType: 'application/json',
    //         success: function (data) {
    //             AppService.refresh();
    //         },
    //         error: function (data) {
    //             console.log(data);
    //
    //             AppService.toggleLoader();
    //
    //             AppService.parseErrors(data.responseJSON, 'user-login');
    //         }
    //     });
    //
    //     return false;
    // }


    function registrationSubmit() {
        var email = $('#js-input-user-registration-email'),
            password = $('#js-input-user-registration-password'),
            repeatPassword = $('#js-input-user-registration-repeatPassword'),
            name = $('#js-input-user-registration-name'),
            phone = $('#js-input-user-registration-phone');

        $('.has-error').removeClass('has-error');
        var isValid = true;

        if (name.val().length < 3) {
            isValid = false;
            AppService.displayError('Обязательное поле', name);
        }

        if (email.val().length < 3) {
            isValid = false;
            AppService.displayError('Обязательное поле', email);
        }

        if (password.val().length < 6) {
            isValid = false;
            AppService.displayError('Пароль не может быть меньше 6 символов', password);
        }

        if (repeatPassword.val() != password.val()) {
            isValid = false;
            AppService.displayError('Пароли не совпадают', repeatPassword);
        }

        var strPhone = phone.val().split('+').join('').split(' ').join('').split('-').join('').split('_').join('');

        if (strPhone.length > 0 && strPhone.length < 11) {
            isValid = false;
            AppService.displayError('Некорректный номер телефона', phone);
        }

        if (!isValid) {
            return false;
        }

        AppService.toggleLoader();

        var data = {
            email: email.val(),
            password: password.val(),
            phone: phone.val(),
            name: name.val()
        };

        $.ajax({
            url: $(this).prop('action'),
            type: $(this).prop('method'),
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function (data) {
                $('#modalUserRegistration').modal('hide');
                $('#js-auth-success-title').html('Поздравляем с успешной регистрацией на СушиВёсла!');
                $('#js-auth-success-content').html('На указанный Вами электронный адрес было выслано письмо.');
                AppService.toggleLoader();
                $('#modalAuthSuccess').modal('show');
            },
            error: function (data) {
                console.log(data);

                AppService.toggleLoader();

                AppService.parseErrors(data.responseJSON, 'user-registration');
            }
        });

        return false;
    }


    function forgotSubmit() {
        var email = $('#js-input-user-forgot-email');

        $('.has-error').removeClass('has-error');
        var isValidate = true;

        if (email.val().length < 3) {
            isValidate = false;
            AppService.displayError('Обязательное поле', email);
        }

        AppService.toggleLoader();

        var data = {
            email: email.val()
        };

        if (isValidate) {
            $.ajax({
                url: $(this).prop('action'),
                type: $(this).prop('method'),
                data: JSON.stringify(data),
                contentType: 'application/json',
                success: function (data) {
                    $('#modalUserForgot').modal('hide');
                    $('#js-auth-success-title').html('Восстановление аккаунта!');
                    $('#js-auth-success-content').html('На указанный Вами электронный адрес было выслано письмо.');
                    AppService.toggleLoader();
                    $('#modalAuthSuccess').modal('show');
                },
                error: function (data) {
                    console.log(data);

                    AppService.toggleLoader();

                    AppService.parseErrors(data.responseJSON, 'user-forgot');
                }
            });

        }
        return false;
    }

    // function forgotPasswordSubmit() {
    //     var password = $('#js-input-user-forgot-password-password'),
    //         repeatPassword = $('#js-input-user-forgot-password-repeatPassword');
    //
    //     $('.has-error').removeClass('has-error');
    //     var isValid = true;
    //
    //     if (password.val().length < 6) {
    //         isValid = false;
    //         AppService.displayError('Пароль не может быть меньше 6 символов', password);
    //     }
    //
    //     if (repeatPassword.val() != password.val()) {
    //         isValid = false;
    //         AppService.displayError('Пароли не совпадают', repeatPassword);
    //     }
    //
    //     if (!isValid) {
    //         return false;
    //     }
    // }

    function init() {

        $(".js-user-registration-link").click(function () {
            $('.modal.in').modal('hide');
            $('#modalUserRegistration').modal('show');
        });

        $(".js-user-login-link").click(function () {
            $('.modal.in').modal('hide');
            $('#modalStartAuthorize').modal('show');
        });

        $('#modalStartAuthorize').on('shown.bs.modal', function (e) {
            LoyaltyService.sendGoogleAnalyticsEventOnCondition(
                2,
                $('main.content').attr('data-general-tab') === 'loyalty-intro'
            );
        });

        // $(".js-user-forgot-link").click(function () {
        //     $('.modal.in').modal('hide');
        //     $('#modalUserForgot').modal('show');
        // });

        // var loginForm = $('#js-user-login-form');
        // if (loginForm.length > 0) {
        //     loginForm.submit(loginSubmit);
        // }

        var registrationForm = $('#js-user-registration-form');
        if (registrationForm.length > 0) {
            registrationForm.submit(registrationSubmit);
        }

        var forgotForm = $('#js-user-email-forgot-form');
        if (forgotForm.length > 0) {
            forgotForm.submit(forgotSubmit);
        }

        // var forgotPasswordForm = $('#js-user-forgot-password-form');
        // if (forgotPasswordForm.length > 0) {
        //     forgotPasswordForm.submit(forgotPasswordSubmit);
        // }
    }

    return {
        init: init
    }
})();

$(AuthService.init);

